import httpService from "../../services/httpService";

const logsService = {
  getAllLogs: (page, limit, filter) => {
    return httpService.post(`getAllLogs?limit=${limit || 10}&page=${page || 1}`,  {params: filter });
  },
  createLogs: () => {
    return httpService.get(`createLogs`);
  },
};

export default logsService;
